import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { paginationBlockStyle } from './paginationBlockStyle.js';
import { shouldRenderPage } from './shouldRenderPage.js';
export const renderPages = (pagesParams, index) => {
    const { currentPage, onPageChange, totalPages } = pagesParams;
    const page = index + 1;
    if (page === currentPage) {
        return (_jsx("div", { "aria-current": "true", className: "py-m @lg:px-lg px-m bg-primary-main text-center min-w-10 @lg:min-w-0 text-white rounded-md", children: page }, String(index)));
    }
    if (page !== 1 && page !== totalPages && shouldRenderPage(page, currentPage, totalPages)) {
        return (_jsx("div", { onClick: () => onPageChange(page), className: paginationBlockStyle, "aria-label": `Страница ${page}`, children: page }, String(index)));
    }
    return null;
};
//# sourceMappingURL=renderPages.js.map